export default __webpack_public_path__ + "static/media/尹强半身像.c065b3d8.png";